module.exports = __webpack_public_path__ + "static/media/our_reserve.ec851a88.svg";